import { render, staticRenderFns } from "./SmsContent.vue?vue&type=template&id=8a5cd4d8&scoped=true&"
import script from "./SmsContent.vue?vue&type=script&lang=js&"
export * from "./SmsContent.vue?vue&type=script&lang=js&"
import style0 from "./SmsContent.vue?vue&type=style&index=0&id=8a5cd4d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5cd4d8",
  null
  
)

export default component.exports